// extracted by mini-css-extract-plugin
export default {"subNav":"SubNav_subNav__qI6jI","horizontalTabList":"SubNav_horizontalTabList__-KxW+","border":"SubNav_border__Xtiv3"};